import router from "./index";
import store from "../store";
router.beforeEach((to, from, next) => {
    if(to.matched.length && !to.matched.some((item) => item.meta.isLogin)){//不需要登录
        next();
    }else{//需要登录
        let user = store.state.login.user;
        if(user){
            next()
        }else{
            next('/login')
        }
    }

  });
